/* Stage 2 "Dashboard" · agent D (card 2.2 Engagements tab; C-14 moves) — EN + AR strings.
   Registered at the end of lib/i18n.js (one import + two _overrideDeep lines). */
export const I18N_DS_D = {
  en: {
    dsD: {
      refCol: "Ref", fyCol: "Financial year", signoffsCol: "Sign-offs",
      readyCol: "Ready to lock",
      reportCol: "Report",
      ready: "Ready",
      openItem: "1 open item",
      openItems: "{n} open items",
      noDate: "—",
      figuresUnavailable: "—",
      stage: {
        planning: "Planning",
        fieldwork: "Fieldwork",
        completion: "Completion",
        reporting: "Reporting",
        locked: "Locked",
      },
      opinion: {
        unmodified: "Unmodified",
        qualified: "Qualified",
        adverse: "Adverse",
        disclaimer: "Disclaimer",
        not_concluded: "Not concluded",
      },
      linkStage: "Open the {stage} page",
      linkSignoffs: "Open the sign-off status",
      linkReady: "Open the lock readiness table",
      linkReport: "Open the auditor's report",
      engDocsTitle: "Engagement-level documents",
      engDocsHint: "Supporting documents for the engagement as a whole (engagement letter, independence confirmations, correspondence). Documents for a worksheet or sample are attached on that worksheet.",
    },
  },
  ar: {
    dsD: {
      refCol: "المرجع", fyCol: "السنة المالية", signoffsCol: "التوقيعات",
      readyCol: "جاهز للإقفال",
      reportCol: "التقرير",
      ready: "جاهز",
      openItem: "بند واحد مفتوح",
      openItems: "{n} بنود مفتوحة",
      noDate: "—",
      figuresUnavailable: "—",
      stage: {
        planning: "التخطيط",
        fieldwork: "العمل الميداني",
        completion: "الاستكمال",
        reporting: "إعداد التقرير",
        locked: "مقفل",
      },
      opinion: {
        unmodified: "غير معدّل",
        qualified: "متحفّظ",
        adverse: "سلبي",
        disclaimer: "امتناع عن إبداء الرأي",
        not_concluded: "لم يُستنتج بعد",
      },
      linkStage: "فتح صفحة {stage}",
      linkSignoffs: "فتح حالة التوقيعات",
      linkReady: "فتح جدول جاهزية الإقفال",
      linkReport: "فتح تقرير المراجع",
      engDocsTitle: "مستندات على مستوى المهمة",
      engDocsHint: "مستندات داعمة للمهمة ككل (خطاب التكليف، تأكيدات الاستقلالية، المراسلات). مستندات ورقة عمل أو عينة تُرفق في تلك الورقة.",
    },
  },
};

export default I18N_DS_D;
